import { render, staticRenderFns } from "./ShortcutsBar.vue?vue&type=template&id=5e02be6a&scoped=true"
import script from "./ShortcutsBar.vue?vue&type=script&lang=js"
export * from "./ShortcutsBar.vue?vue&type=script&lang=js"
import style0 from "./ShortcutsBar.vue?vue&type=style&index=0&id=5e02be6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e02be6a",
  null
  
)

export default component.exports